"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BoundingShape;
function BoundingShape(rect, area, box) {
    var _this = this;
    this._rect = rect;
    this._bounds = area;
    this._boundingBox = box;
    this.isColliding = false;
    this.updateBoundingBox = function () {
        throw new Error('Implement update bounding box');
    };
    this.setIsColliding = function (isColliding) {
        _this.isColliding = isColliding;
        if (_this._draw) {
            _this._draw();
        }
    };
}
